// Page "Choisir mon tamis" — contenu (claim/desc/composition/specs/ressenti)
// vient desormais du metaobjet "Raquettes" (voir snippets/raquettes-data.liquid,
// injecte par sections/tamis-picker.liquid dans window.HexagonRaquettesData)
// — 2026-07-25, demande explicite de ne plus dupliquer ce texte en dur ici.
// testsHash (ancre vers la page Tests terrain) reste en dur : c'est du
// routing interne, pas du contenu editorial.
(function () {
  var ASSETS = window.HexagonTamisPickerAssets || { illustrations: {} };
  var TESTS_HASH = { mc: 'equilibree', cc: 'puissance1', lin: 'confort' };

  // 2026-08-31 : galerie photo produit — memes fichiers que le
  // configurateur (finition "brut", calque logo "tricolore"), voir
  // snippets/configurator-media.liquid pour la convention de nommage et
  // sections/tamis-picker.liquid pour l'injection de MEDIA.
  var MEDIA = window.HexagonTamisPickerMedia || { photos: {}, logos: {} };
  var GALLERY_TAMIS_SLUGS = { mc: 'equilibre', cc: 'puissance', lin: 'controle' };
  var GALLERY_PHOTO_COUNT = 4;

  var RAQUETTES_DATA = window.HexagonRaquettesData || [];
  var MATIERES = window.HexagonMatieresData || {};

  // Brief "Page Tamis" (2026-08-14) : cle presence_* (metaobjects.tamis) ->
  // cle MATIERES (snippets/matieres-data.liquid), dans l'ordre d'affichage
  // demande du detail des fibres.
  var PRESENCE_TO_MATIERE = [
    ['presenceChanvre', 'chanvre'],
    ['presenceCarboneTisse', 'carbone_tisse'],
    ['presenceCarboneNonTisse', 'carbone_non_tisse'],
    ['presenceVerre', 'verre']
  ];

  function money(n) { return n + ' €'; }

  var TAMIS = RAQUETTES_DATA.map(function (r) {
    return {
      id: r.id,
      label: r.label,
      claim: r.claim,
      tester: r.tester,
      testsHash: TESTS_HASH[r.id],
      desc: r.desc,
      resume: r.resume,
      title: r.title,
      composition: r.composition,
      specsCommunes: r.specsCommunes || {},
      specsFibres: r.specsFibres || {},
      pricing: r.pricing || {},
      ressenti: r.ressenti
    };
  });

  // 2026-08-02 : les notes hors "Global" passent en radar (araignee) plutot
  // qu'en listes de points empilees — feedback explicite. Le tamis
  // selectionne ressort en couleur (accent vert atelier), les 2 autres
  // restent visibles en arriere-plan, grises, pour comparer d'un coup d'oeil
  // sans devoir naviguer entre les 3 fiches.
  var RADAR_AXES = [
    ['maniabilite', 'Maniabilité'],
    ['confort', 'Confort'],
    ['controle', 'Contrôle'],
    ['puissance', 'Puissance'],
    ['rigidite', 'Rigidité']
  ];
  var RADAR_MAX = 5;

  function radarPoint(cx, cy, r, i, n) {
    var angle = (-90 + (i * 360 / n)) * Math.PI / 180;
    return [cx + r * Math.cos(angle), cy + r * Math.sin(angle)];
  }

  function radarPolygonPoints(values, cx, cy, R) {
    var n = RADAR_AXES.length;
    return values.map(function (v, i) {
      var pt = radarPoint(cx, cy, (Math.max(0, Math.min(v, RADAR_MAX)) / RADAR_MAX) * R, i, n);
      return pt[0] + ',' + pt[1];
    }).join(' ');
  }

  function renderRadarSvg(tamisList, activeId) {
    // 2026-08-10 : graph recentre dans son viewBox (cx/cy = centre exact) ;
    // les 2 tamis non selectionnes perdent leur remplissage (contour seul,
    // "plus leger/transparent") et ne se distinguent plus par 2 gris mais
    // par 2 pointilles differents (dotted / tirets espaces) — "plus simple
    // a differencier que le gris".
    var cx = 100, cy = 85, R = 60;
    var n = RADAR_AXES.length;
    var svg = '';

    // Grille de fond (anneaux 20/40/60/80/100%) + axes.
    [0.2, 0.4, 0.6, 0.8, 1].forEach(function (frac) {
      var pts = [];
      for (var i = 0; i < n; i++) pts.push(radarPoint(cx, cy, R * frac, i, n).join(','));
      svg += '<polygon class="tp-radar__grid" points="' + pts.join(' ') + '" />';
    });
    for (var i = 0; i < n; i++) {
      var end = radarPoint(cx, cy, R, i, n);
      svg += '<line class="tp-radar__axis" x1="' + cx + '" y1="' + cy + '" x2="' + end[0] + '" y2="' + end[1] + '" />';
    }

    // Polygones des tamis non selectionnes d'abord (contour seul), le tamis
    // selectionne en dernier pour ressortir au-dessus.
    var bgIndex = 0;
    var ordered = tamisList.filter(function (t) { return t.id !== activeId; })
      .concat(tamisList.filter(function (t) { return t.id === activeId; }));
    ordered.forEach(function (t) {
      var values = RADAR_AXES.map(function (a) { return (t.ressenti || {})[a[0]] || 0; });
      var isActive = t.id === activeId;
      var shapeClass = isActive ? ' is-active' : (bgIndex++ === 0 ? ' is-dotted' : ' is-dashed');
      svg += '<polygon class="tp-radar__shape' + shapeClass + '" points="' + radarPolygonPoints(values, cx, cy, R) + '" />';
    });

    // Libelles des axes — meme taille que les autres labels du site
    // (voir .tp-radar__label, calee sur .tp-ressenti__label).
    for (var j = 0; j < n; j++) {
      var labelPt = radarPoint(cx, cy, R + 18, j, n);
      var anchor = Math.abs(labelPt[0] - cx) < 4 ? 'middle' : (labelPt[0] > cx ? 'start' : 'end');
      svg += '<text class="tp-radar__label" x="' + labelPt[0] + '" y="' + labelPt[1] + '" text-anchor="' + anchor + '">' + RADAR_AXES[j][1] + '</text>';
    }

    return '<svg class="tp-radar__svg" viewBox="0 0 200 170" aria-hidden="true">' + svg + '</svg>';
  }

  var root = document.querySelector('.tp-picker');
  if (!root) return;
  var selectRow = document.querySelector('[data-tp-select]');

  var TP_GALLERY_MAIN_LABEL = 'Photo produit — tamis sélectionné';

  function tpPlaceholderHtml(label) {
    return '<div class="media-placeholder media-placeholder--square media-placeholder--sable"><span class="media-placeholder__label">' + label + '</span></div>';
  }

  // 2026-08-31 : `file_url` (Liquid) ne renvoie jamais une chaine vide pour
  // un fichier absent (voir snippets/configurator-media.liquid) — une
  // combinaison pas encore uploadee 404 au chargement plutot que d'etre
  // absente de MEDIA. Detecte donc l'echec cote JS (comme dans
  // assets/configurateur.js) plutot que de se fier a une cle manquante.
  function tpPhotoCellHtml(tamisId, n, label) {
    var slug = GALLERY_TAMIS_SLUGS[tamisId];
    var photo = MEDIA.photos[slug + '|brut|' + n];
    if (!photo) return tpPlaceholderHtml(label);
    var logo = MEDIA.logos[n + '|tricolore'];
    var html = '<div class="tp-gallery__photo-cell tp-gallery__photo-cell--pending"><img src="' + photo + '" alt="" loading="lazy">';
    if (logo) html += '<img src="' + logo + '" alt="" loading="lazy" class="tp-gallery__photo-overlay">';
    html += '</div>';
    return html;
  }

  // Photo ET calque doivent apparaitre ensemble (une seule cellule reste
  // cachee jusqu'a ce que les 2 <img> aient fini de charger), meme
  // mecanisme que wirePhotoCellFallback() dans assets/configurateur.js.
  function tpWirePhotoCellFallback(container, label) {
    var cell = container.querySelector('.tp-gallery__photo-cell');
    if (!cell) return;
    var imgs = cell.querySelectorAll('img');
    if (!imgs.length) return;
    var mainImg = imgs[0];
    var overlayImg = imgs[1] || null;
    var pending = overlayImg ? 2 : 1;
    function maybeReveal() {
      pending--;
      if (pending <= 0) cell.classList.remove('tp-gallery__photo-cell--pending');
    }
    function failMain() { container.innerHTML = tpPlaceholderHtml(label); }
    if (mainImg.complete) {
      if (mainImg.naturalWidth > 0) { maybeReveal(); } else { failMain(); return; }
    } else {
      mainImg.addEventListener('load', maybeReveal, { once: true });
      mainImg.addEventListener('error', failMain, { once: true });
    }
    if (overlayImg) {
      if (overlayImg.complete) {
        if (overlayImg.naturalWidth > 0) { maybeReveal(); } else { overlayImg.remove(); maybeReveal(); }
      } else {
        overlayImg.addEventListener('load', maybeReveal, { once: true });
        overlayImg.addEventListener('error', function () {
          overlayImg.remove();
          maybeReveal();
        }, { once: true });
      }
    }
  }

  function renderGallery(tamisId) {
    var mainEl = document.querySelector('[data-tp-gallery-main]');
    if (!mainEl) return;
    mainEl.innerHTML = tpPhotoCellHtml(tamisId, 1, TP_GALLERY_MAIN_LABEL);
    tpWirePhotoCellFallback(mainEl, TP_GALLERY_MAIN_LABEL);
    document.querySelectorAll('[data-tp-gallery-thumb]').forEach(function (thumb, i) {
      var n = i + 1;
      var label = 'Photo ' + n;
      thumb.innerHTML = tpPhotoCellHtml(tamisId, n, label);
      tpWirePhotoCellFallback(thumb, label);
    });
  }

  (function initGallerySwap() {
    var mainEl = document.querySelector('[data-tp-gallery-main]');
    if (!mainEl) return;

    // 2026-07-29 : plus de pop-in — la miniature cliquee echange sa photo
    // avec l'image principale (la grande photo vient prendre la place de
    // la miniature cliquee, comme sur une fiche produit classique).
    function swap(thumb, thumbLabel) {
      var mainMedia = mainEl.querySelector('.media-placeholder, .tp-gallery__photo-cell');
      var thumbMedia = thumb.querySelector('.media-placeholder, .tp-gallery__photo-cell');
      if (!mainMedia || !thumbMedia) return;
      var mainHtml = mainMedia.outerHTML;
      var thumbHtml = thumbMedia.outerHTML;
      mainMedia.outerHTML = thumbHtml;
      thumbMedia.outerHTML = mainHtml;
      // outerHTML recree des noeuds tout neufs : les listeners load/error
      // poses par tpWirePhotoCellFallback sont perdus, on les repose ici.
      tpWirePhotoCellFallback(mainEl, TP_GALLERY_MAIN_LABEL);
      tpWirePhotoCellFallback(thumb, thumbLabel);
    }

    document.querySelectorAll('[data-tp-gallery-thumb]').forEach(function (thumb, i) {
      var thumbLabel = 'Photo ' + (i + 1);
      thumb.addEventListener('click', function () { swap(thumb, thumbLabel); });
    });
  })();

  var currentId = TAMIS[0].id;
  if (window.location.hash) {
    var fromHash = window.location.hash.replace('#', '');
    if (TAMIS.some(function (t) { return t.id === fromHash; })) currentId = fromHash;
  }

  function dots(n, total) {
    total = total || 5;
    var out = '';
    for (var i = 0; i < total; i++) {
      out += '<span class="tp-dot' + (i < n ? ' is-on' : '') + '"></span>';
    }
    return '<span class="tp-dots">' + out + '</span>';
  }

  function row(label, value) {
    return '<div class="datasheet__row"><span class="datasheet__label">' + label + '</span><span class="datasheet__value">' + value + '</span></div>';
  }

  function renderSelector() {
    selectRow.innerHTML = TAMIS.map(function (t) {
      var active = t.id === currentId;
      return '<button type="button" class="tamis-option' + (active ? ' is-active' : '') + '" data-tp-id="' + t.id + '" aria-pressed="' + active + '">' +
        '<span class="tamis-option__indicator" aria-hidden="true"></span>' +
        '<span class="tamis-option__icon" aria-hidden="true"><svg viewBox="0 0 48 48"><path d="M24 4 41 14v20L24 44 7 34V14L24 4Z"/></svg></span>' +
        '<span class="tamis-option__content">' +
          '<span class="tamis-option__title">' + t.label + '</span>' +
        '</span>' +
        '</button>';
    }).join('');
    selectRow.querySelectorAll('[data-tp-id]').forEach(function (el) {
      el.addEventListener('click', function () {
        currentId = el.getAttribute('data-tp-id');
        history.replaceState(null, '', '#' + currentId);
        render();
      });
    });
  }

  function render() {
    var t = TAMIS.filter(function (x) { return x.id === currentId; })[0];
    renderSelector();
    renderGallery(currentId);

    document.querySelector('[data-tp-quote]').textContent = '« ' + t.claim + ' »';
    document.querySelector('[data-tp-author]').textContent = t.tester;
    document.querySelector('[data-tp-surface]').textContent = t.resume;
    document.querySelector('[data-tp-joueur]').textContent = t.desc;

    var schemaIcon = document.querySelector('[data-tp-schema-icon]');
    schemaIcon.innerHTML = '<img src="' + (ASSETS.illustrations[t.id] || '') + '" alt="">';
    document.querySelector('[data-tp-schema-rows]').innerHTML = t.composition.map(function (c) {
      return '<li>' + c + '</li>';
    }).join('');

    document.querySelector('[data-tp-detail-title]').textContent = t.title;

    var sc = t.specsCommunes;
    document.querySelector('[data-tp-specs-communes]').innerHTML = [
      ['Forme', sc.forme],
      ['Épaisseur', sc.epaisseur],
      ['Résine', sc.resine],
      ['Noyau', sc.noyau],
      ['Superficie de frappe', sc.superficieFrappe]
    ].map(function (r) { return row(r[0], r[1]); }).join('');

    var sf = t.specsFibres;
    document.querySelector('[data-tp-specs-fibres]').innerHTML = row('Fibres', sf.densiteFibres);
    document.querySelector('[data-tp-fibres-detail]').innerHTML = PRESENCE_TO_MATIERE
      .filter(function (pair) { return sf[pair[0]]; })
      .map(function (pair) {
        var m = MATIERES[pair[1]] || {};
        return '<li><strong>' + (m.nom || '') + '</strong> — ' + (m.infosCompo || '') + '</li>';
      }).join('');

    document.querySelector('[data-tp-prix-raquette]').textContent = money(t.pricing.raquette);
    document.querySelector('[data-tp-prix-tamis]').textContent = money(t.pricing.tamis);

    // Meme ordre / meme regle que renderRadarSvg() pour que le pointille de
    // la legende corresponde toujours a celui du polygone (1er non-
    // selectionne rencontre dans TAMIS = pointille, 2e = tirets).
    var legendBgIndex = 0;
    var legend = TAMIS.map(function (x) {
      var isActive = x.id === currentId;
      var cls = isActive ? ' is-active' : (legendBgIndex++ === 0 ? ' is-dotted' : ' is-dashed');
      return '<span class="tp-radar__legend-item' + cls + '">' +
        '<span class="tp-radar__legend-dot"></span>Tamis ' + x.label + '</span>';
    }).join('');
    document.querySelector('[data-tp-radar]').innerHTML = renderRadarSvg(TAMIS, currentId) + '<div class="tp-radar__legend">' + legend + '</div>';

    var testsLink = document.querySelector('[data-tp-tests-link]');
    var baseUrl = testsLink.getAttribute('href').split('#')[0];
    testsLink.setAttribute('href', baseUrl + '#' + t.testsHash);

    // 2026-09-05 (Lot 4) : renvoie vers la page dediee /pages/configurer-
    // ma-raquette (plus le bloc configurateur de la HP) — ?style=<id> lu
    // par assets/configurateur.js quelle que soit la page (window.location.
    // search), aucun changement necessaire cote configurateur.
    var configureCta = document.querySelector('[data-tp-configure-cta]');
    if (configureCta) configureCta.setAttribute('href', '/pages/configurer-ma-raquette?style=' + t.id);
  }

  render();
})();
